<div class="container">

  @for (item of dashBoardInfos$ | async; track item.text) {
    <div  class=".vertical-center" style="margin: 5rem;">
      <h1 class="grid">
        @if (!item.islieferant) {
          <i style="font-size: var(--fontSizeBigger); color:cornflowerblue;  margin-right: 1.5rem; margin-bottom: auto; margin-top: auto; "
          class="pi pi-exclamation-circle"></i>
        }
        <div [style]="item.islieferant ? 'margin-top: 10rem;'  : '' " [innerHTML]="item.text" > </div>
      </h1>
    </div>
  }
  <div class="grid" >
    @if (ismanager == true && (this.selecthasSOMADiagramm$ | async)   ) {
      <div class="col-6">
        <app-novitaetendiagramm-soma ></app-novitaetendiagramm-soma>
      </div>
    }
    <div [class]="ismanager == true && (this.selecthasSOMADiagramm$ | async)  ? 'col-6': 'col'" >
      <app-notifications></app-notifications>
    </div>
  </div>

</div>
